/** Normalize category user_view / user_edit from API (string[] or { role: string }[]). */
export function normalizeCategoryRoles(raw: unknown): string[] {
  if (!Array.isArray(raw)) return [];
  return raw
    .map((entry) => (typeof entry === "string" ? entry : entry?.role))
    .filter((role): role is string => typeof role === "string" && role.trim().length > 0);
}

/** User role is listed under category Edit access. */
export function canEditCategoryByRole(userRole: string | undefined, userEdit: unknown): boolean {
  const role = userRole?.trim();
  if (!role) return false;
  return normalizeCategoryRoles(userEdit).includes(role);
}

/** User role is listed under View Only or Edit access. */
export function canViewCategoryByRole(
  userRole: string | undefined,
  userView: unknown,
  userEdit: unknown
): boolean {
  const role = userRole?.trim();
  if (!role) return false;
  const viewRoles = normalizeCategoryRoles(userView);
  const editRoles = normalizeCategoryRoles(userEdit);
  return viewRoles.includes(role) || editRoles.includes(role);
}
